import { Component, Input} from '@angular/core';

@Component({
  selector: 'rmt-accordion',
  templateUrl: 'rmt-accordion.html'
})
export class RmtAccordionComponent {
  @Input() data: rmtAccordionData;
  contentShow;

  constructor() {
  }

  toggleContentShow(event) {
    if (this.contentShow === event.target.id) {
      this.contentShow = null;
    } 
    else
      this.contentShow = event.target.id
  }

}

export interface rmtAccordionData {
  [index: number]: {
    id: string;
    title: string;
    details: string;
    actionString?: string; 
    actionFunction?: Function;
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-accordion/rmt-accordion.ts